import { render } from "./SelecionaPlanoTreino.vue?vue&type=template&id=1fc54db7"
import script from "./SelecionaPlanoTreino.vue?vue&type=script&lang=js"
export * from "./SelecionaPlanoTreino.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__